<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.75"
      d="M9.567 7.133a5.562 5.562 0 1 1 11.125 0V22.43"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.75"
      d="M5.395 11.305a4.172 4.172 0 0 1 8.344 0H5.395ZM6.09 14.086l-.695 2.086M4.004 20.344 3.31 22.43M13.043 14.086l.695 2.086M15.129 20.344l.695 2.086M9.567 14.086v2.086M9.567 22.43v-2.086"
    />
  </svg>
</template>
